import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import {
  getRechargeSettingAction,
  getRechargeChannelsAction,
  getBankListAction,
  getRechargeMoneyAction,
  getRechargeRecordAction,
  getremitListAction,
  getauditListAction,
  getBankCardInform,
  surePayedForAction,
  notPayedForAction,
  getRemitCardInform
} from "../action/rechargeManagementAction";

export const rechargeManagementReducer = (
  builder: ActionReducerMapBuilder<{
    rechargeSettingConfig: any;
    rechargeLine: any[];
    bankList: any[];
    rechargeMoney: any[];
    rechargeRecord: any;
    tauditList: any;
    remitList: any;
    payedList: any;
    notPayedList: any;
    bankCardInform: any,
    remitCardInform: any
  }>
) => {
  builder.addCase(getRechargeSettingAction.fulfilled, (state, { payload }) => {
    state.rechargeSettingConfig = payload;
  });
  builder.addCase(getBankListAction.fulfilled, (state, { payload }) => {
    state.bankList = payload;
  });
  builder.addCase(getRechargeChannelsAction.fulfilled, (state, { payload }) => {
    state.rechargeLine = payload;
  });
  builder.addCase(getRechargeMoneyAction.fulfilled, (state, { payload }) => {
    state.rechargeMoney = payload;
  });
  builder.addCase(getRechargeRecordAction.fulfilled, (state, { payload }) => {
    state.rechargeRecord = payload;
  });
  builder.addCase(getauditListAction.fulfilled, (state, { payload }) => {
    state.tauditList = payload;
  });
  builder.addCase(getremitListAction.fulfilled, (state, { payload }) => {
    state.remitList = payload;
  });
  builder.addCase(surePayedForAction.fulfilled, (state, { payload }) => {
    state.payedList = payload
  }); //TODO: Add action to confirm
  builder.addCase(notPayedForAction.fulfilled, (state, { payload }) => {
    state.notPayedList = payload
  }); 
  builder.addCase(getBankCardInform.fulfilled, (state, { payload }) => {
    state.bankCardInform = payload
  });
  builder.addCase(getRemitCardInform.fulfilled, (state, { payload }) => { 
    state.remitCardInform = payload
  } );
};
